import React from "react";
import Navbar from "../../common/Navbar";
import Footer from "../../common/Footer";
import { useState, useEffect } from "react";
import * as Constants from "../../../Constants/index";
import axios from "axios";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import { useFormik } from "formik";
import ResponsivePagination from "react-responsive-pagination";
import Oval from "../loader/CircleLoade";
import { Link } from "react-router-dom";

const ClaimOnPurchaseValue = () => {
  const navigate = useNavigate();
  const userType = localStorage.getItem("user_type");
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10);
  const [filterData, setFilterData] = useState({});
  const [downloadLoading, setDownloadLoading] = useState(false);

  useEffect(() => {
    getReportData(
      {
        mobile: "",
        status: "",
        startDate: "",
        endDate: "",
        merchantId: "",
      },
      1
    );
  }, []);

  const searchFormik = useFormik({
    initialValues: {
      mobile: "",
      status: "",
      startDate: "",
      endDate: "",
      merchantId: "",
    },
    validate: (data) => {
      let errors = {};
      if (data.mobile) {
        if (data.mobile.length < 10) {
          errors.mobile = "Mobile must be in 10 digits.";
        }
      }
      if (data.startDate === "" && data.endDate !== "") {
        errors.startDate = "Please select date";
      }
      if (data.startDate !== "" && data.endDate === "") {
        errors.endDate = "Please select date";
      }
      if (data.startDate && data.endDate && data.startDate > data.endDate) {
        errors.endDate = "Please select date";
      }
      if (data.startDate && data.endDate && data.startDate > data.endDate) {
        errors.endDate = "End date should be greater than start date";
      }
      return errors;
    },
    onSubmit: (data) => {
      setCurrentPage(1);
      getReportData(data, 1);
      setFilterData(data);
    },
  });

  const isSearchFormFieldValid = (name) =>
    !!(searchFormik.touched[name] && searchFormik.errors[name]);

  const getSearchFormErrorMessage = (name) => {
    return (
      isSearchFormFieldValid(name) && (
        <small className="report-error-field">
          {searchFormik.errors[name]}
        </small>
      )
    );
  };

  const getReportData = async (data, pageNum) => {
    setLoading(true);
    if (!token) {
      navigate("/");
    } else {
      // Build query parameters
      const searchMobile = data?.mobile ? `&mobile=${data.mobile}` : "";
      const searchStatus = data?.status
        ? `&status=${encodeURIComponent(data.status)}`
        : "";
      const UsermerchantId = data?.merchantId
        ? `&merchantId=${data.merchantId}`
        : "";

      let stDate = "";
      let endDate = "";

      if (data?.startDate && data?.endDate) {
        const startFormattedDate = moment(data.startDate).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        const endFormattedDate = moment(data.endDate).format(
          "YYYY-MM-DD 23:59:59"
        );
        stDate = `&start=${startFormattedDate}`;
        endDate = `&end=${endFormattedDate}`;
      }

      // Combine all parameters
      const queryParams = `${searchMobile}${searchStatus}${UsermerchantId}${stDate}${endDate}`;

      try {
        const response = await axios.get(
          Constants.baseUrl +
            `reports/claimOnPurchaseValue/list?sortBy=createdDateTime&sortAsc=true&limit=${limit}&page=${pageNum}${queryParams}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Accept-Language": localStorage.getItem("langauge"),
              appVersion: Constants.av,
              platform: Constants.pt,
              company: Constants.company,
              program: Constants.program,
            },
          }
        );

        const dt = response.data;
        if (dt.result === "success") {
          setReportData(dt?.output?.results);
          setTotalPages(dt?.output?.totalPages);
        } else {
          setReportData(null);
          setTotalPages(0);
        }
      } catch (err) {
        console.error("Error fetching report data:", err);
        setReportData(null);
        setTotalPages(0);
      } finally {
        setLoading(false);
      }
    }
  };

  const download = async (data) => {
    setLoading(true);
    setDownloadLoading(true);

    try {
      // Build query parameters for download
      const searchMobile = data?.mobile ? `&mobile=${data.mobile}` : "";
      const UsermerchantId = data?.merchantId
        ? `&merchantId=${data.merchantId}`
        : "";
      const searchStatus = data?.status
        ? `&status=${encodeURIComponent(data.status)}`
        : "";

      let stDate = "";
      let endDate = "";

      if (data?.startDate && data?.endDate) {
        const startFormattedDate = moment(data.startDate).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        const endFormattedDate = moment(data.endDate).format(
          "YYYY-MM-DD 23:59:59"
        );
        stDate = `&start=${startFormattedDate}`;
        endDate = `&end=${endFormattedDate}`;
      }

      // Combine all parameters for download
      const queryParams = `${searchMobile}${searchStatus}${UsermerchantId}${stDate}${endDate}`;

      const response = await axios.get(
        Constants.baseUrl +
          `reports/download/claimOnPurchaseValue?${queryParams}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: Constants.program,
          },
          responseType: "blob",
        }
      );

      if (response.status === 200) {
        const fileData = new Blob([response.data], { type: "text/csv" });
        saveAs(fileData, "Claim-On-Purchase-Value.csv");
      } else {
        swal({
          text: response.data.msg || "Download failed",
          timer: 2000,
          buttons: false,
        });
      }
    } catch (error) {
      console.error("Download error:", error);
      swal({
        text: "An error occurred during download",
        timer: 2000,
        buttons: false,
      });
    } finally {
      setLoading(false);
      setDownloadLoading(false);
    }
  };

  const resetBtn = () => {
    searchFormik.resetForm();
    setReportData(null);
    setTotalPages(0);
    setCurrentPage(1);
    setFilterData({});
    getReportData(
      {
        mobile: "",
        status: "",
        startDate: "",
        endDate: "",
        merchantId: "",
      },
      1
    );
  };

  const areAllValuesBlank = () => {
    const { mobile, status, startDate, endDate } = searchFormik.values;
    return !mobile && !status && !startDate && !endDate;
  };

  return (
    <>
      <Navbar />
      <section className="page-content--bge55">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <h3 className="head1">Claim On Purchase Value Report</h3>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <form onSubmit={searchFormik.handleSubmit}>
                <div className="row">
                  <div className="col-lg-9 col-md-12 col-sm-12 col-xs-12">
                    <div className="row">
                      <div className="col-md-3 col-sm-12 col-xs-12">
                        <div className="form-group">
                          <input
                            className="form-control reset"
                            type="text"
                            placeholder="Mobile No."
                            id="mobile"
                            value={searchFormik.values.mobile}
                            onChange={(e) => {
                              const numericValue = e.target.value
                                .replace(/\D/g, "")
                                .slice(0, 10);
                              searchFormik.handleChange({
                                target: {
                                  name: "mobile",
                                  value: numericValue,
                                },
                              });
                            }}
                          />
                          {getSearchFormErrorMessage("mobile")}
                        </div>
                      </div>
                      <div className="col-md-3 col-sm-12 col-xs-12">
                        <DatePicker
                          id="startDate"
                          selected={searchFormik.values.startDate}
                          onChange={(date) =>
                            searchFormik.setFieldValue("startDate", date)
                          }
                          dateFormat="dd-MM-yyyy"
                          className="form-control"
                          showYearDropdown
                          showMonthDropdown
                          autoComplete="off"
                          scrollableYearDropdown
                          maxDate={new Date()}
                          onKeyDown={(e) => e.preventDefault()}
                          onFocus={(e) => e.target.blur()}
                          onClick={(e) => e.preventDefault()}
                          placeholderText="From date"
                        />
                        {getSearchFormErrorMessage("startDate")}
                      </div>
                      <div className="col-md-3 col-sm-12 col-xs-12">
                        <DatePicker
                          id="endDate"
                          selected={searchFormik.values.endDate}
                          onChange={(date) =>
                            searchFormik.setFieldValue("endDate", date)
                          }
                          dateFormat="dd-MM-yyyy"
                          className="form-control"
                          showYearDropdown
                          showMonthDropdown
                          autoComplete="off"
                          scrollableYearDropdown
                          maxDate={new Date()}
                          onKeyDown={(e) => e.preventDefault()}
                          onFocus={(e) => e.target.blur()}
                          onClick={(e) => e.preventDefault()}
                          placeholderText="To date"
                        />
                        {getSearchFormErrorMessage("endDate")}
                      </div>
                      <div className="col-md-3 col-sm-12 col-xs-12">
                        <select
                          className="form-control"
                          id="status"
                          value={searchFormik.values.status}
                          onChange={searchFormik.handleChange}
                        >
                          <option value="">Select Status</option>
                          <option value="APPROVED">Approved</option>
                          <option value="REJECTED">REJECTED</option>
                          <option value="PENDING">PENDING</option>
                        </select>
                        {getSearchFormErrorMessage("status")}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-12 col-sm-12 col-xs-12 mb-3">
                    <div className="d-flex justify-content-between gap-3">
                      <button
                        type="submit"
                        className="btn btn-primary report-submit-button"
                      >
                        Search
                      </button>
                      <button
                        style={{ marginLeft: "10px" }}
                        type="button"
                        className="btn btn-primary report-submit-button"
                        onClick={resetBtn}
                      >
                        Reset
                      </button>

                      <Link
                        to=""
                        style={{ marginTop: "10px" }}
                        className={`btn btn-primary report-submit-button mx-5${
                          downloadLoading ? "btn-opacity" : ""
                        }`}
                        onClick={() => download(searchFormik.values)}
                      >
                        {downloadLoading ? (
                          <span>
                            <i className="fa fa-spinner fa-spin"></i>Export
                          </span>
                        ) : (
                          " Export"
                        )}
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="row"></div>
              </form>
              <div className="row mt-20">
                <div className="col-md-12">
                  <div className="table-responsive table--no-card">
                    <table className="table table-borderless table-striped table-earning">
                      <thead>
                        <tr>
                          <th>Claim Id</th>
                          <th>Product Claim Id</th>
                          <th>Member Unique Id</th>
                          <th>Plumber Name</th>
                          <th>Mobile</th>
                          <th>Zone</th>
                          <th>Branch</th>
                          <th>User Work State</th>
                          <th>User Work District</th>
                          <th>User Work City</th>
                          <th>Pincode</th>
                          <th>FS Name</th>
                          <th>FS Mobile</th>
                          <th>Fs Code</th>
                          <th>Retailer Merchant Id</th>
                          <th>Retailer Firm Name</th>
                          <th>Retailer Mobile</th>
                          <th>Claim Date</th>
                          <th>Month Of Claim</th>
                          <th>Status</th>
                          <th>Remarks</th>
                          <th>Purchase Value</th>
                          <th>Pride Points</th>
                          <th>Bonus Points</th>
                          <th>Total Points</th>
                          <th>Approval / Rejection Date Time</th>
                          <th>Beat Code</th>
                          <th>Beat Plan Name</th>
                          <th>Territory Code</th>
                          <th>Territory Name</th>
                          <th>preferredRetailerId</th>
                          <th>noOfEmployees</th>
                        </tr>
                      </thead>
                      {reportData === null ? (
                        <tbody>
                          <tr>
                            <td
                              colSpan="38"
                              style={{ textAlign: "start", fontSize: "16px" }}
                            >
                              No record found!
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody>
                          {reportData &&
                            reportData.map((item, index) => {
                              const serialNumber =
                                (currentPage - 1) * limit + index + 1;
                              return (
                                <tr key={index}>
                                  <td>{item[0]}</td>
                                  <td>{item[1]}</td>
                                  <td>{item[2]}</td>
                                  <td>{item[3]}</td>
                                  <td>{item[4]}</td>
                                  <td>{item[5]}</td>
                                  <td>{item[6]}</td>
                                  <td>{item[7]}</td>
                                  <td>{item[8]}</td>
                                  <td>{item[9]}</td>
                                  <td>{item[10]}</td>
                                  <td>{item[11]}</td>
                                  <td>{item[12]}</td>
                                  <td>{item[13]}</td>
                                  <td>{item[14]}</td>
                                  <td>{item[15]}</td>
                                  <td>{item[16]}</td>
                                  <td>{item[17]}</td>
                                  <td>{item[18]}</td>
                                  <td>{item[19]}</td>
                                  <td>{item[20]}</td>
                                  <td>{item[21]}</td>
                                  <td>{item[22]}</td>
                                  <td>{item[23]}</td>
                                  <td>{item[24]}</td>
                                  <td>{item[25]}</td>
                                  <td>{item[26]}</td>
                                  <td>{item[27]}</td>
                                  <td>{item[28]}</td>
                                  <td>{item[29]}</td>
                                  <td>{item[30]}</td>
                                  <td>{item[31]}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                      )}
                    </table>
                    {totalPages > 1 && (
                      <ResponsivePagination
                        current={currentPage}
                        total={totalPages}
                        onPageChange={(page) => {
                          setCurrentPage(page);
                          getReportData(filterData, page);
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default ClaimOnPurchaseValue;
